
import { Options, Vue } from "vue-class-component";
import { StudentRecord } from "../interfaces/student";
import { db } from "../firebase";

import firebase from "firebase/app";
import "firebase/firestore";

import moment from "moment";

interface StudentCheckinReport {
  absense: number;
  late: number;
}

@Options({
  watch: {
    async students() {
      if (this.students.size == 0) return;
      const statistic = new Map<string, StudentCheckinReport>();
      this.students.forEach((student: StudentRecord) => {
        statistic.set(student.seatNumber, { absense: 0, late: 0 });
      });

      const snapshot = await db
        .collection("checkins")
        .where(firebase.firestore.FieldPath.documentId(), ">=", "1598976000000")
        .get();

      snapshot.docs.forEach((doc) => {
        const dayStart = parseInt(doc.id);
        const d = new Date(dayStart);
        const day = d.getDay();
        if (day > 5 || day < 1) {
          console.log("ignore", d);
          return;
        }
        const dayLateTime = new Date(dayStart).setHours(7, 26, 0, 0);
        const data = doc.data();
        for (const [seatNumber, student] of statistic) {
          const checkinTime = data[seatNumber];
          if (!checkinTime) {
            student.absense += 1;
          } else if (parseInt(checkinTime) > +dayLateTime) {
            student.late += 1;
          }

          statistic.set(seatNumber, student);
        }
      });
      // console.log(JSON.stringify(Array.from(statistic.entries()), null, 2));
      this.statistic = statistic;
      return;
    },
  },

  methods: {
    moment: function (checkinTime: number): string {
      if (checkinTime) {
        return moment(checkinTime).format("HH:mm");
      }
      return "";
    },
  },

  props: {
    students: new Map<string, StudentRecord>(),
  },

  data() {
    return {
      statistic: new Map<string, StudentCheckinReport>(),
    };
  },
})
export default class Today extends Vue {}
